import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Form from "./form";
import Input from "./input";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Textarea from "./textarea";
import _questions from "./_questions";

export default function Questions({ person, page, total }) {
  const isCIR = person !== undefined ? person.membership_type === 'Creative in Residence' : false;
  const nextUrl = isCIR ? "/apply/customs" : "/apply/battery-powered-video";
  const submitUrl = "/api/applications/v4/application/questions/";
  const {
    data: {
      results: [
        {
          submission: { questions }
        }
      ]
    }
  } = useQuery(["application"]);
  const [form, setForm] = useState({ ...questions, errors: null });
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="The nitty gritty.">
        <P>Let’s get down to business. Tell us why you really want to be a member.</P>
      </PageHeader>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} submitUrl={submitUrl}>
        {_questions.map((n, idx) => {
          if (isCIR && idx === 1) {
            return (
              <Input
                form={form}
                key={idx}
                name="question2"
                setForm={setForm}
                type="hidden"
                value="CIR"
              />
            )
          } else {
            return (
              <Textarea
                key={idx}
                name={`question${idx + 1}`}
                label={n.question}
                placeholder={n.placeholder}
                form={form}
                setForm={setForm}
                value={form[`question${idx + 1}`]}
              />
            )
          }
        })}
      </Form>
    </Page>
  );
}
